import React, { useState } from 'react';

import { ChevronDown } from 'lucide-react';

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/shadcn/ui/collapsible';
import { cn } from '@/utils';

import HeaderMenuDrawerSingle from './HeaderMenuDrawerSingle';

interface HeaderMenuDrawerCollapsibleProps {
  initialOpen?: boolean;
  label: string | React.ReactNode;
  children: React.ReactNode;
  Icon: React.FC<{ className?: string }>;
}

const HeaderMenuDrawerCollapsible: React.FC<HeaderMenuDrawerCollapsibleProps> = ({
  initialOpen = false,
  Icon,
  label,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const toggleCollapse = () => setIsOpen(!isOpen);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger
        asChild
        onClick={toggleCollapse}
        className={cn({
          'bg-background hover:bg-background rounded-b-none': isOpen,
        })}
      >
        <HeaderMenuDrawerSingle Icon={Icon}>
          <div className="flex w-full items-center justify-between">
            {label}
            <ChevronDown className={cn('size-4 transition-transform duration-200', { 'rotate-180': isOpen })} />
          </div>
        </HeaderMenuDrawerSingle>
      </CollapsibleTrigger>

      <CollapsibleContent
        className="bg-background/60 grid grid-cols-1 rounded-b-xl *:m-1 *:w-[calc(100%-8px)] *:bg-transparent *:p-3"
      >
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
};

export default HeaderMenuDrawerCollapsible;
